(function (angular) {
  'use strict';

  angular.module('app').controller('signinController', signinController);

  signinController.$inject = ['$http', '$scope', 'queryParams'];

  function signinController($http, $scope, queryParams) {
    var vm = this;

    // properties
    vm.loading = false;
    vm.errors = {};
    vm.messages = {
      unauthorised:
        'You need to be signed in to do that. <br />Sign in below or create a new account.',
      loginRequired:
        'You need to be signed in to access this site. <br />Sign in below.',
    };
    vm.message = vm.messages[queryParams.message] || '';

    // methods
    vm.signin = signin;

    // check next parameter is a URL for the current site, if not set to null
    var nextHost = getHostName(queryParams.next);
    var currentHost = window.location.host;

    if (nextHost != currentHost) {
      queryParams.next = null;
    }

    /**
     * Authenticates the user with the API
     * @return {void}
     */
    function signin() {
      vm.errors = {};

      if (vm.signinForm.$valid) {
        vm.loading = true;

        $http
          .post(
            '/signin',
            {
              email: vm.email,
              password: vm.password,
              remember_me: vm.remember_me,
            },
            {
              responseType: 'json',
            },
          )
          .then(function (res) {
            vm.loading = false;

            if (res.status === 200 && 'r' in res.data) {
              window.location = res.data['r'];
            } else if (res.status === 200) {
              window.location = queryParams.next || '/';
            }
          })
          .catch(function (errors) {
            // handle 403, redirection for MFA
            if (errors.status === 403 && errors.data?.redirect) {
              window.location.href = errors.data.redirect;
              return;
            }
            vm.loading = false;
            vm.errors = errors.data;
          });
      }
    }

    /**
     * Extracts hostname from a given url
     *
     * @param {string} url
     * @return {void}
     */
    function getHostName(url) {
      if (typeof url === 'undefined') {
        return null;
      }

      var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
      if (
        match != null &&
        match.length > 2 &&
        typeof match[2] === 'string' &&
        match[2].length > 0
      ) {
        return match[2];
      } else {
        return null;
      }
    }
  }
})(angular);
